import { render, staticRenderFns } from "./ContributionEdition.vue?vue&type=template&id=d534ec84&scoped=true&"
import script from "./ContributionEdition.vue?vue&type=script&lang=js&"
export * from "./ContributionEdition.vue?vue&type=script&lang=js&"
import style0 from "./ContributionEdition.vue?vue&type=style&index=0&id=d534ec84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d534ec84",
  null
  
)

export default component.exports